<app-card-base
  [title]="'Se connecter'"
  [hasSubmit]="true"
  [submitText]="b2cUser ? 'Se connecter' : 'Suivant'"
  (onSubmitEvent)="onSubmit()"
  [loading]="loading"
  [isDisabled]="loginForm.invalid || (b2cUser && !passwordFilled)"
>
  <ng-container main *ngTemplateOutlet="content"></ng-container>
  <ng-container footer *ngTemplateOutlet="footer"></ng-container>
</app-card-base>

<ng-template #content>
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <div>
      <!-- email -->
      <mat-form-field class="col-12">
        <mat-label>Adresse Email</mat-label>
        <input
          type="email"
          matInput
          formControlName="username"
          placeholder="Adresse Email"
          required
          autocomplete="username"
          name="username"
          id="username"
        />
        <mat-icon
          *ngIf="f('username').value"
          matSuffix
          role="button"
          appTooltip="Supprimer l'adresse mail"
          (click)="resetLogin()"
          >close</mat-icon
        >
        <mat-error *ngIf="f('username').hasError('required')">
          <span>Veuillez saisir votre adresse email</span>
        </mat-error>
        <mat-error *ngIf="f('username').hasError('email')">
          <span>Veuillez saisir une adresse email valide</span>
        </mat-error>
        <mat-error *ngIf="f('username').hasError('unknownEmail')">
          <span>Email inconnu. Vérifiez-le ou créez votre compte.</span>
        </mat-error>
      </mat-form-field>
      <!-- password b2c -->
      <mat-form-field *ngIf="b2cUser" class="col-12">
        <mat-label>Mot de passe</mat-label>
        <input
          [type]="hidePassword ? 'password' : 'text'"
          #password
          matInput
          formControlName="password"
          placeholder="Mot de passe"
          autocomplete="current-password"
          (keyup.enter)="onSubmit()"
          (ngModelChange)="onPasswordCHange($event)"
        />
        <mat-icon
          matSuffix
          role="button"
          [appTooltip]="
            hidePassword
              ? 'Afficher le mot de passe'
              : 'Masquer le mot de passe'
          "
          (click)="hidePassword = !hidePassword"
          >{{ hidePassword ? "visibility_off" : "visibility" }}</mat-icon
        >
        <mat-error *ngIf="f('password').hasError('required')">
          <span>Veuillez saisir votre mot de passe</span>
        </mat-error>
      </mat-form-field>
    </div>
  </form>
</ng-template>

<ng-template #footer>
  <!-- forgot -->
  <div *ngIf="b2cUser" class="text-end mt-3">
    <a routerLink="/password-lost" [queryParams]="getQueryParams()"
      >Mot de passe oublié ?</a
    >
  </div>
  <div *ngIf="!b2cUser" class="create-account">
    <button
      mat-flat-button
      color="primary"
      routerLink="/register"
      [queryParams]="getQueryParams()"
    >
      Créer son compte gratuitement
    </button>
  </div>
</ng-template>
